// src/components/FacebookFeed.jsx
import React, { useEffect } from 'react';
import { Paper, Typography, Box } from '@mui/material';

export default function FacebookFeed() {
  // Load Facebook SDK if not already present
  useEffect(() => {
    if (document.getElementById('facebook-jssdk')) {
      // If SDK already loaded, re-parse XFBML
      if (window.FB) window.FB.XFBML.parse();
      return;
    }

    // Insert fb-root div
    const fbRoot = document.createElement('div');
    fbRoot.id = 'fb-root';
    document.body.appendChild(fbRoot);

    // Load SDK script
    const script = document.createElement('script');
    script.id = 'facebook-jssdk';
    script.src =
      'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v17.0';
    script.async = true;
    document.body.appendChild(script);

    // Once loaded, parse XFBML
    script.onload = () => {
      if (window.FB) window.FB.XFBML.parse();
    };
  }, []);

  return (
    <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
      <Typography variant="h6" fontWeight={700} gutterBottom>
        Follow Us on Facebook
      </Typography>

      <Box
        sx={{
          // Ensure the plugin fits responsively
          '& .fb-page': { width: '100% !important' },
        }}
      >
        <div
          className="fb-page"
          data-href="https://www.facebook.com/Lemda.webdevelopment"
          data-tabs="timeline"
          data-width="500"
          data-height="600"
          data-small-header="false"
          data-adapt-container-width="true"
          data-hide-cover="false"
          data-show-facepile="true"
        />
      </Box>
    </Paper>
  );
}
